/* global window, document, jQuery, setTimeout, alert */
/* eslint-disable */

var sImgSrcPLoading = "/img/web/icons/icon_process_loading.gif";
var sImgSrcPDone = "/img/web/icons/icon_process_done.gif";
var sImgSrcPError = "/img/web/icons/icon_process_error.gif";
var sImgSrcPNone = "/img/web/icons/icon_process_none.gif";

/**
 * Autocomplete cache
 * @var array
 */
var cache_autocomplete = {};

/**
 * Default min characters for autocomplete fields
 * @var int
 */
var autocomplete_min_length = 2;

/**
 * Default min miliseconds autocomplete start
 * @var int
 */
var autocomplete_delay = 260;

/**
* Array with autocomplete field ids
*
* @var array
*/
var aAutocomplete = [];

/**
* Array with related fields with other autocompletes
*
* @var array
*/
var aAutocompleteRel = [];

window.App = (function ($) {

    var Application = function () {

        // Sets device querying functions, must be set on onload page event.
        this.isSmartphone = function () { return $('html').hasClass('mobile');};
        this.isDesktop =    function () { return $('html').hasClass('desktop'); };
        this.isTablet =     function () { return $('html').hasClass('tablet'); };
        this.isIphone =     function() { return $('html').hasClass('iphone'); };

        // Generic pageVar attribute for dynamic data.
        this.pageVar = {};

        /**
         * Generic modal dialog box with Yes/No options.
         * Executes a function if it's accepted.
         *
         * @param object   callbackData Data to pass to the callbackfunction, this parameter is optional
         * @param function callback Function to execute when click accept button
         *
         * @return void
         * @author Sergi Soler i Segura<ssoler@intercomempresas.com>
         * @since  Sprint 2011.21 (IET-3212)
         */
        this.ConfirmDialog = function (callbackData, callback) {
            "use strict";

            var data= null;

            if (typeof callbackData == 'object') {
                data= callbackData;
            }
            if (typeof callbackData == 'function') {
                callback= callbackData;
            }
            if (typeof callback !== 'function') {
                return false;
            }

            var element = function () {
                var confirmContainer = $('<div>', {
                    'class': 'js_confirm_dialog brds-round3'
                });
                var TitleTxt = $('<strong>', {
                    'class': 'js_confirm_txt'
                });
                var DescriptionTxt = $('<p>', {
                    'class': 'js_confirm_desc'
                });
                var Button = function () {
                    var ButtonContainer = $('<div>', {
                        'class': 'text-align-C'
                    });
                    var btn = $('<button>', {
                        type: 'button',
                        'id': 'js_confirm_btn',
                        'class': 'js_confirm_btn confirm_btn brds-round',
                        text: configurations.labels.COMMON_accept_btn
                    });
                    var cancelAnchor = $('<a>', {
                        'class': 'cancel-lnk',
                        text: configurations.labels.menuCommonActionDiscard
                    });
                    $(ButtonContainer).append(btn, cancelAnchor);
                    return ButtonContainer;
                }();

                $(confirmContainer).append(TitleTxt, DescriptionTxt, Button);

                $(confirmContainer).dialog({
                    width: 460,
                    autoOpen: false,
                    resizable: false,
                    draggable: false,
                    modal: true
                });

                $(confirmContainer).parent().find('.ui-dialog-titlebar').hide();

                return confirmContainer;
            }();

            var closeFunction = function () {
                $(element).dialog('close');
            };

            this.show = function () {
                $(element).dialog('open');
            };
            this.showModal = function () {
                $(element).dialog("option", "modal", true);
                this.show();
            };
            this.hide = function () {
                $(element).dialog('close');
            };
            this.destroy = function () {
                $(element).dialog('destroy');
            };
            // Set dialog message
            this.setMessage = function (msg) {
                $(element).find('.js_confirm_txt').html(msg);
            };
            // Set dialog description
            this.setDescription = function (msg) {
                $(element).find('.js_confirm_desc').html(msg);
            };
            // Overrides Cancel default behavior by the given one in func.
            this.setCancelFunction = function (func) {
                // Detach default Cancel behavior
                $(element).find('a.cancel-lnk').unbind();
                // Attach new behavior
                $(element).find('a.cancel-lnk').on('click', function () {
                    func();
                    closeFunction();
                });
            };
            // Set option after init.
            this.setOption = function (op, val) {
                $(element).dialog('option', op, val);
            };

            //Click event for confirm button
            $(element).find('.js_confirm_btn').unbind();
            if (data == null) {
                $(element).find('.js_confirm_btn').on('click', function () {
                    callback();
                    closeFunction();
                });
            } else {
                $(element).find('.js_confirm_btn').on('click', {data : data},function (event) {
                    callback({data : event.data.data});
                    closeFunction();
                });
            }

            // Click event for cancel button
            $(element).find('a.cancel-lnk').unbind();
            $(element).find('a.cancel-lnk').on('click', closeFunction);
        };

        /**
         * Generic modal dialog box with only Accept option.
         *
         * @param object   div        DOM element
         *
         * @return void
         * @author Sergi Soler i Segura <ssoler@intercomempresas.com>
         * @since  Sprint 2011.21 (IET-3212)
         */
        this.AcceptDialog = function () {
            "use strict";

            var element = function () {
                var acceptContainer = $('<div>', {
                    'class': 'js_loading brds-round3'
                });
                var TitleTxt = $('<strong>', {
                    'class': 'js_confirm_txt'
                });
                var DescriptionTxt = $('<p>', {
                    'class': 'js_confirm_desc'
                });

                var Button = function () {
                    var ButtonContainer = $('<div>', {
                        'class': 'text-align-C'
                    });
                    var btn = $('<button>', {
                        type: 'button',
                        'id': 'js_confirm_btn',
                        'class': 'js_confirm_btn confirm_btn brds-round',
                        text: configurations.labels.COMMON_accept_btn
                    });
                    $(ButtonContainer).append(btn);
                    return ButtonContainer;
                }();

                $(acceptContainer).append(TitleTxt, DescriptionTxt, Button);

                $(acceptContainer).dialog({
                    width: 380,
                    autoOpen: false,
                    resizable: false,
                    draggable: false,
                    closeOnEscape: false
                });
                $(acceptContainer).parent().find('.ui-dialog-titlebar').hide();

                return acceptContainer;
            }();

            var closeFunction = function () {
                $(element).dialog('close');
            };

            this.show = function () {
                $(element).dialog('open');
            };
            this.showModal = function () {
                $(element).dialog("option", "modal", true);
                this.show();
            };
            this.hide = function () {
                $(element).dialog('close');
            };
            this.destroy = function () {
                $(element).dialog('destroy');
            };
            // Set dialog message
            this.setMessage = function (msg) {
                $(element).find('.js_confirm_txt').html(msg);
            };
            // Set dialog description
            this.setDescription = function (msg) {
                $(element).find('.js_confirm_desc').html(msg);
            };
            // Overrides Accept default behavior by the given one in func.
            this.setAcceptFunction = function (func) {
                // Detach default Cancel behavior
                $(element).find('.js_confirm_btn').unbind();
                // Attach new behavior
                $(element).find('.js_confirm_btn').click(function () {
                    func();
                    closeFunction();
                });
            };
            // Overrides Accept default behavior by the given one in func.
            this.setAcceptFunctionWidthData = function (data, func) {
                // Detach default Cancel behavior
                $(element).find('.js_confirm_btn').unbind();
                // Attach new behavior
                $(element).find('.js_confirm_btn').click({data : data}, function (data) {
                    func(data.data);
                    closeFunction();
                });
            };
            // Set option after init.
            this.setOption = function (op, val) {
                $(element).dialog('option', op, val);
            };
            this.addClass = function (className) {
                $(element).find('.js_accept_dialog').addClass(className);
            };
            this.removeClass = function (className) {
                $(element).find('.js_accept_dialog').removeClass(className);
            };

            // Click event for accept button
            $(element).find('.js_confirm_btn').on('click', closeFunction);
        };

        /**
         * Generic loading with dialog
         *
         * @param object   div        DOM element
         *
         * @return void
         * @author David Juarez Merelo <djuarez@intercomempresas.com>
         * @since  Sprint 2011.21 (IET-3212)
         */
        this.Loading = function () {

            var element = function () {
                // Define source of image
                var sImgSrcLoading = "/img/web/ajax-loader.gif";

                var loadingContainer = $('<div>', {
                    'class': 'js_loading brds-round3'
                });

                var loadingTxt = $('<strong>', {
                    text: configurations.labels.commonLoadingLbl
                });

                var loadingImg = $('<img>', {
                    alt: configurations.labels.commonLoadingLbl,
                    src: sImgSrcLoading
                });

                $(loadingContainer).append(loadingTxt, loadingImg);

                $(loadingContainer).dialog({
                    autoOpen: false,
                    resizable: false,
                    draggable: false,
                    closeOnEscape: false
                });
                $(loadingContainer).parent().find('.ui-dialog-titlebar').hide();

                return loadingContainer;
            }();

            var timeIni = 0;
            var timeEnd = 0;

            this.show = function () {
                $(element).dialog('open');
                var date = new Date();
                timeIni = date.getTime();
            };
            this.showModal = function () {
                $(element).dialog("option", "modal", true);
                this.show();
            };
            this.hide = function () {
                $(element).dialog('close');
            };
            this.hideDelayed = function (delay) {
                var date = new Date();
                timeEnd = date.getTime();
                if ((timeEnd - timeIni) < delay) {
                    setTimeout(this.hide, delay);
                } else {
                    $(element).dialog('close');
                }
            };
        };

        /**
         * Generic loading with dialog
         *
         * @param string divId       ID for the div container.
         * @param bool   overViewMap Indicates if overview map, must be displayed.
         *
         * @return void
         * @author David Juarez Merelo <djuarez@intercomempresas.com>
         * @since  Sprint 2013.03 (IET-5058)
         */
        this.Map = function (divId, overViewMap) {
            var self = this, div = null;
            if (typeof divId == 'string') {
                div = document.getElementById(divId);
            } else {
                div = divId;
            }
            var overViewMapSet = overViewMap || false;
            var mapOptions = {
                zoom: 10,
                center: new google.maps.LatLng(0, 0),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                streetViewControl: false,
                overviewMapControl: overViewMapSet,
                overviewMapControlOptions: {opened: true}
            };
            var GMap = new google.maps.Map(div, mapOptions);
            var markerList = [];
            var infoWindow = null;
            var directionsService = null, directionsDisplay = null;
            var geocoder = null;

            this.setIdlCallback = function setIdlCallback(callback) {
                window.google.maps.event.addListener(GMap, 'idle', callback);
            };

            this.setDragCallback = function setDragCallback(callback) {
                window.google.maps.event.addListener(GMap, 'drag', callback);
            };

            this.setZoomCallback = function setZoomCallback(callback) {
                window.google.maps.event.addListener(GMap, 'zoom_changed', callback);
            };

            this.setCenter = function (lat, lng) {
                GMap.setCenter(new google.maps.LatLng(lat, lng));
                return self;
            };

            this.resetMarkers = function () {
                for (var i in markerList) {
                    markerList[i].setMap(null);
                }
                markerList = [];
                self.show(true);
            };

            this.addMarker = function (lat, lng, title, content, draggable, icon) {
                var latlng = new google.maps.LatLng(lat, lng);

                draggable = draggable || false;
                var markerOptions = {
                    position: latlng,
                    map: GMap,
                    title: title,
                    draggable: draggable
                };
                if (icon) {
                    markerOptions.icon = icon;
                }

                var marker = new google.maps.Marker(markerOptions);

                if (content) {
                    google.maps.event.addListener(marker, 'click', function (event) {
                        if (infoWindow) {
                            infoWindow.close();
                        }
                        infoWindow = new google.maps.InfoWindow({
                            content: content, position: marker.getPosition(), maxWidth: 200, zIndex: 1005
                        });
                        infoWindow.open(GMap, this);
                    });
                }

                markerList.push(marker);

                return marker;
            };

            this.setStatic = function () {
                GMap.setOptions({
                    draggable: false,
                    disableDoubleClickZoom: true,
                    scrollwheel: false,
                    disableDefaultUI: true
                });
                return self;
            };
            this.setZoom = function (zoom) {
                GMap.setZoom(zoom);
                return self;
            };

            this.getZoom = function () {
                return GMap.getZoom();
            };

            this.setOptions = function (options) {
                options = options || {};
                GMap.setOptions(options);
                return self;
            };
            this.search = function (address, addmarker, done, fail) {
                if (geocoder === null) {
                    geocoder = new google.maps.Geocoder();
                }
                var request = {'address': address};
                geocoder.geocode(request, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        if (typeof done === 'function') {
                            if (!done(results[0])) {
                                return false;
                            }
                        }
                        if (addmarker === true) {
                            self.setCenter(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                            self.addMarker(results[0].geometry.location.lat(), results[0].geometry.location.lng(), address);
                            self.show(true);
                        }
                    } else {
                        if (typeof fail === 'function') {
                            fail();
                        }
                    }
                });
            };
            this.go = function (from, to, cleandirections) {
                if (directionsService === null) {
                    directionsService = new google.maps.DirectionsService();
                }
                if (directionsDisplay === null) {
                    directionsDisplay = new google.maps.DirectionsRenderer();
                }
                directionsDisplay.setMap(GMap);
                if (cleandirections === true) {
                    directionsDisplay.set('directions', null);
                }
                var request = {
                    origin: from,
                    destination: to,
                    travelMode: google.maps.DirectionsTravelMode.DRIVING
                };
                directionsService.route(request, function (response, status) {
                    if (status == google.maps.DirectionsStatus.OK) {
                        directionsDisplay.setDirections(response);
                    }
                });
            };
            this.show = function (bDisplayAllMarkers) {
                var bDisplay = bDisplayAllMarkers || false;

                google.maps.event.trigger(div, 'resize');

                if (bDisplay && (markerList.length > 1)) {
                    var bounds = new google.maps.LatLngBounds();
                    for (index in markerList) {
                        bounds.extend(markerList[index].getPosition());
                    }
                    GMap.fitBounds(bounds);
                }

                return self;
            };
            return self;
        };
    };

    return new Application();

})(jQuery);

function ATmaxlen(text, maxlong)
{
    // onKeyDown = "return ATmaxlen(this,maxlong);"
    var tecla, int_value, out_value, in_value;
    if (text.value.length > maxlong) {
        in_value = text.value;
        out_value = in_value.substring(0, maxlong);
        text.value = out_value;
        return false;
    }
    return true;
}

function modifyMinDate(sDateText, sObjName)
{
    var aDate = sDateText.split('-');
    var dDate = new Date(aDate[2], parseInt(aDate[1], 10) - 1, parseInt(aDate[0], 10));
    dDate.setHours(23, 59, 59, 999);

    var sDateOld = document.getElementById(sObjName).value;
    var aDateOld = sDateOld.split('-');
    var dDateOld = new Date(aDateOld[2], parseInt(aDateOld[1], 10) - 1, aDateOld[0]);

    if (dDate > dDateOld) {
        aDate[0] = dDate.getDate();
        aDate[1] = dDate.getMonth() + 1;
        aDate[2] = dDate.getFullYear();
        if (aDate[0] < 10) {
            aDate[0] = "0" + aDate[0];
        }
        if (aDate[1] < 10) {
            aDate[1] = "0" + aDate[1];
        }
        $('#' + sObjName).datepicker('setDate', dDate);
        document.getElementById(sObjName).value = aDate[0] + "-" + aDate[1] + "-" + aDate[2];
    }

    $('#' + sObjName).datepicker('change', { minDate: dDate});
}

function setClassOnParentIfChecked (objId, className) {

    if ($(objId + ':checked').length != 0) {
        $(objId).parent().parent().addClass(className);
    } else {
        $(objId).parent().parent().removeClass(className);
    }

}

/**
 * Checks service of the subservice
 *
 * @param {Object} sev_id
 *
 * @author Xavier Vidal Ponsa <xaviv@intercomempresas.com>
 * @since  Sprint 2011.11 (IET-2947)
 */
function checkServiceCheck(sev_id)
{
    if ($('.jv_sev_parent_' + sev_id + ':checked').length === 0) {
        $('#sev_' + sev_id).prop('checked', false);
    } else {
        $('#sev_' + sev_id).prop('checked', true);
    }
    setClassOnParentIfChecked('#sev_' + sev_id, "active");
}

/**
 * Checks/unchecks services of a parent service
 *
 * @param int sev_id Service parent id
 *
 * @return void
 * @author Xavier Vidal Ponsa <xaviv@intercomempresas.com>
 * @since  Sprint 2011.11 (IET-2947)
 */
function checkSubservice(sev_id)
{
    $('.jv_sev_parent_' + sev_id).each( function(element) {
        $(this).prop('checked', $('#sev_' + sev_id).is(':checked'));
        setClassOnParentIfChecked('#' + $(this).context.id,"active");
    });
    setClassOnParentIfChecked('#sev_' + sev_id, "active");
}

// used in CWeb
function order(value)
{
    var regexp = new RegExp(/[&|\?]ord=(.*)/);
    var match = regexp.exec(url);

    if (match != null) {
        newvalue = url.replace(match[1], escape(value));
    } else {
        if (url.indexOf('?') != -1){
            newvalue = url + "&ord=" + escape(value);
        } else {
            newvalue = url + "?ord=" + escape(value);
        }
    }

    window.document.location = newvalue;
}

function check_float_format (sValue,cThousands,cDecimals)
{
    if (cDecimals == cThousands) {
        return -1;
    }

    var aParts = sValue.split(cDecimals);

    if (typeof aParts[1]!= "undefined") {
        // check decimals
        if (typeof aParts[2]!= "undefined") {
            return -1;
        }
        if (!IsNumeric(aParts[1])){
            return -1;
        }

    }
    // check integer value
    var aInt = aParts[0].split(cThousands);
    if (aInt.length > 1) {
        for (key in aInt) {

            if (aInt[key].length > 3) {
                return -1;
            }
            if (!IsNumeric(aInt[key])){
                return -1;
            }

            if (key==0) continue;

            if (aInt[key].length < 3) {
                return -1;
            }
        }
    } else {
        if (!IsNumeric(aInt[0])){
            return -1;
        }
    }

    if (typeof aParts[1] == "undefined") {
        var RDecimal = "";
    } else {
        var RDecimal = '.' + aParts[1];
    }

    return parseFloat(aInt.join('') + RDecimal);
}

function IsNumeric(expression)
{
    return (String(expression).search(/^\d+$/) != -1);
}

/**
 * Sets standard datepicker
 *
 * @return void
 * @author Xavier Vidal Ponsa <xaviv@intercomempresas.com>
 * @since Sprint 2011.15 (FIX)
 */
function setDatePicker()
{
    // Limits beginning date
    var aDate = "01-01-2007";
    aDate = aDate.split('-');
    var dDate = new Date(
        aDate[0], parseInt (aDate[1], 10) - 1, parseInt(aDate[2], 10)
    );

   $('#startdate').datepicker({
       dateFormat: 'dd-mm-yy',
       minDate: dDate,
       onSelect: function (dateText) {
           modifyMinDate(dateText, 'enddate');
       }
   });

   $('#enddate').datepicker({dateFormat: 'dd-mm-yy'});
}

/**
 * Allows to change project from the admin header selector
 *
 * @param string url_pro Project url for current page
 *
 * @return void
 * @author Xavier Vidal Ponsa <xaviv@intercomempresas.com>
 * @since Sprint 2011.15 (FIX)
 */
function url_admin(url_pro)
{
    var urlAction = window.location.href;
    urlAction = urlAction.replace(/pro=[0-9]*/, 'pro=' + url_pro);
    urlAction = urlAction.replace(/&com=[0-9]*/, '');

    // This url param is used in the Admin_Semaphore_Price controller.
    urlAction = urlAction.replace(/&replicate=[0-9]*/, '');

    window.location.href = urlAction;
}

/**
 * Company autocomplete action attached to the select event, sets the company
 * id on a field form
 * Standard action attached to the event
 *
 * @param event
 * @param data  Data item has the current selected item
 *
 * @return void
 */
var selectAutocompleteItemCompany = function(event, data)
{
    if (data.item) {
        if (data.item.com_id != 0) {
            $('#com_id').val(data.item.com_id);
        }
    }
};

/**
 * CompanySnippetAuthor autocomplete action attached to the select event, sets the snippet author
 * id on a field form
 * Standard action attached to the event
 *
 * @param event
 * @param data  Data item has the current selected item
 *
 * @return void
 */
var selectAutocompleteItemCompanySnippetAuthor = function(event, data)
{
    if (data.item) {
        if (data.item.sac_id != 0) {
            $('#sac_id').val(data.item.sac_id);
        }
    }
};

/**
 * Company autocomplete action attached to the select event, calls a page defined
 * function called setCompany
 * Standard action attached to the event
 *
 * @param event
 * @param data  Data item has the current selected item
 *
 * @return void
 */
var selectAutocompleteItemCompanyCallback = function(event, data)
{
    if (data.item) {
        if (data.item.com_id != 0) {
            setCompany(data.item.com_id);
        }
    }
};

/**
 * Sets JQuery UI autocomplete for a given field id
 *
 * @param string fieldId        Field id
 * @param string urlCall        Url to return JSON data array of items
 * @param array  extraParams    Array of extra parameters to pass in the request
 * @param string selectCallback Callback function to handle selection
 *
 * @deprecated Use jquery.autocompletecustom.js
 *
 * @return void
 */
function setAutocompleteField(fieldId, urlCall, extraParams, selectCallback) {
    if (typeof(fieldId) != "object") {
        fieldId = '#' + fieldId;
    }

    var $field = $(fieldId),
        $html = $('html');

    // Checks field existence
    if ($field.length < 1) {
        return false;
    }

    $field.autocomplete({
        minLength: autocomplete_min_length,
        delay: autocomplete_delay,
        extraParams: extraParams,
        selectFirst: true,
        source: function (request, response) {

            var term = request.term;
            var parameters = {
                q: term
            };
            // Extends parameters with defined extraparameters
            $.extend(parameters, this.options.extraParams);

            if (!(fieldId in cache_autocomplete)) {
                cache_autocomplete[fieldId] = {};
            }

            // Checks cache to return result
            if (term in cache_autocomplete[fieldId]) {
                response(cache_autocomplete[fieldId][term].data);
                return;
            }

            lastXhr = $.getJSON(urlCall, parameters, function(responseData, status, xhr) {
                // Ensures that loading icon disappears, it seems that api one is
                // not working properly
                $(fieldId).removeClass("ui-autocomplete-loading");

                // Add the result fot the term in the cache to avoid future server
                // calls
                cache_autocomplete[fieldId][term] = responseData;
                if (xhr === lastXhr) {
                    response(responseData.data);
                }
            });
        },
        select: selectCallback,
        focus: function(event, ui) {
            if (ui.hasOwnProperty('item') &&
                ($html.hasClass('mobile') || $html.hasClass('tablet')) &&
                $field.data('no-focus') !== undefined) {
                $field.val(ui.item.label);
                if(typeof selectCallback === 'function') {
                    selectCallback(event, ui);
                }
                $field.autocomplete('close');
            } else{
                event.preventDefault();
            }
        }
    });

    var autoComplete = $field.data("ui-autocomplete");

    autoComplete._renderItem = function(ul, item) {
        return $("<li></li>")
            .data("ui-autocomplete-item", item)
            .append("<a>" + item.label + "</a>")
            .appendTo(ul);
    };

    $(".ui-autocomplete-input").on("autocompleteopen", function () {
        var autoComplete = $(this).data("ui-autocomplete");
        menu = autoComplete.menu;

        if (!autoComplete.options.selectFirst) {
            return;
        }

        if (menu.activate) {
            menu.activate(
                $.Event({ type: "mouseenter" }),
                menu.element.children().first()
            );
        }
    });
}

function getURLParameter(name)
{
    return decodeURIComponent(
        (location.search.match(RegExp("[?|&]"+name+'=(.+?)(&|$)'))||[,null])[1]
    );
}

/**
 * Appends goal template just after body tag.
 * Also checks for cancel icon to close the div.
 *
 * @return void
 * @autor  Xavier Vidal Ponsa <xaviv@intercomempresas.com>
 * @since  Sprint 2013.04 (IET-5200)
 *
 * @deprecated Use Namespace.utilities.goalMessage
 */
function createGoal(template)
{
    // aesthetic case
    var $goalContainer = $('.js_alert_container');
    if ($goalContainer.length !== 0) {
        $goalContainer.html(template);
        return;
    }

    var goalDiv = $(template);
    goalDiv.find('.js_icon-close-goal').on('click',
        {parentDiv: goalDiv},
        function (a) {
            a.data.parentDiv.remove();
        }
    );
    $('div .msg-error, div .msg-success, div .msg-alert').remove();
    $('body').prepend(goalDiv);
}

/**
 * Attaches InfoBox funcions at onready document
 */
$(document).ready(function() {
    // Sets datepicker, if any
    if ($('.js_calendar_form').length > 0) {
        setDatePicker();
    }

    /**
     * Mobile Filters.
     * If device is Smartpone, change filter styles.
     *
     * @see: filter_left_module.html
     */
    $(".filter-show-mobile").click(function (event) {

        if ($(this).html() == '<span class="icon-arrow-right"></span>') {
            // Hides filter title.
            $("#selectorsMobile .js_filter_title").hide();
            $(this).html('<span class="icon-arrow-down"></span>');
        } else {
            $(this).html('<span class="icon-arrow-right"></span>');
        }

        $("#selectorsMobile").slideToggle(200);
    });

});
/* eslint-enable */
